import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HVACCopyGlyph = /*#__PURE__*/createElement("g", {
  id: "hvac_copy"
}, /*#__PURE__*/createElement("path", {
  d: "M68.7 12.8h-38c-1.4 0-2.5 1.1-2.5 2.5v12.9H15.3c-1.4 0-2.5 1.1-2.5 2.5v38c0 1.4 1.1 2.5 2.5 2.5h38c1.4 0 2.5-1.1 2.5-2.5V55.8h12.8c1.4 0 2.5-1.1 2.5-2.5v-38c.1-1.4-1.1-2.5-2.4-2.5zM52.8 68.2h-37v-37h37v37zm15.4-15.4H55.8V30.7c0-1.4-1.1-2.5-2.5-2.5H31.2V15.8h37v37z"
}), /*#__PURE__*/createElement("path", {
  d: "M34.3 49c-.7-.1-1.2.1-1.8.3-.2.1-.4.1-.6.2 0 .1 0 .2-.1.3.2.1.4.2.5.3.3.2.5.4.7.6.4.4.8.8 1.1 1.3.3.3.5.7.7 1.1.5 1.3-1.4 3.4-2.7 3.3-1.6-.2-.9-2.3-.5-3.5.1-.7-.1-1.2-.3-1.9-.1-.2-.2-.5-.2-.7h-.3c-.1.2-.2.4-.3.5-.2.3-.4.5-.6.8l-1.2 1.2c-.3.3-.7.5-1.1.7-1.2.5-3.3-1.5-3.2-2.9.1-1.6 2.1-.9 3.4-.5.7.1 1.2-.1 1.8-.3.2-.1.4-.2.6-.2v-.3c-.2-.1-.4-.2-.5-.3-.3-.2-.5-.4-.7-.6-.4-.4-.8-.8-1.1-1.3-.3-.4-.5-.7-.7-1.1-.5-1.3 1.4-3.4 2.7-3.3 1.5.2.9 2.3.5 3.5-.1.7.1 1.2.2 1.9.1.2.1.4.2.6h.3c.1-.2.2-.3.2-.4.2-.3.4-.5.6-.8l1.2-1.2c.3-.3.7-.5 1.1-.7 1.2-.5 3.3 1.5 3.2 2.8.1 1.7-1.9 1-3.1.6z"
}), /*#__PURE__*/createElement("path", {
  d: "M46.4 40.4v6.7h-2.9c-1.6 0-2.9 1.3-3 2.9-.2 4.9-4.2 8.7-9.1 8.7-5 0-9.1-4.1-9.1-9.1s4.1-9.1 9.1-9.1h15m1.9-3.1H31.4c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.5 0 11.8-5.2 12.1-11.6h4.8c.6 0 1.2-.5 1.2-1.2V38.6c-.1-.7-.6-1.2-1.2-1.2z"
}));
const HVACCopy = createSvg({
  name: 'hvac_copy',
  path: HVACCopyGlyph
});

export default HVACCopy;
export { HVACCopyGlyph };
